module.exports = __webpack_public_path__ + "static/img/nr1-2.19ac745.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/nr1-2.png
// module id = 676
// module chunks = 0